angular
    .module("skillBuilderSaaS")
    .filter("checkboxIcon", function () {
    return function (input) {
        return input
            ? "<i class='f-s-16 ion ion-android-checkbox-outline m-r-5'></i>"
            : "<i class='f-s-16 ion ion-android-checkbox-outline-blank m-r-5'></i>";
    };
});
